import { useCallback, useEffect, useState } from "react";

export const usePromise = <T>(fx: () => Promise<T>) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();
  const [data, setData] = useState<T>();

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fx();
      setData(result);
      setError(undefined);
      setLoading(false);
    } catch (exc) {
      setError(exc);
      setLoading(false);
    }
  }, [fx]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
};
